/**
 * Custom component
 * This file has been created to recreate Binding Section
 * Keycloak Version: 25.0.6
 * Date: 18/10/2024
 */

import { lazy } from "react";
import type { Path } from "react-router-dom";
import { generateEncodedPath } from "../../utils/generateEncodedPath";
import type { AppRouteObject } from "../../routes";

const BindingSection = lazy(() => import("../BindingSection"));

export const BindingRoute: AppRouteObject = {
  path: "/:realm/binding",
  element: <BindingSection />,
  breadcrumb: (t) => t("binding"),
  handle: {
    access: ["view-realm", "view-identity-providers", "view-clients"],
  },
};
